module.exports = __webpack_public_path__ + "static/dashboard-40f53d4347fd8cab203e169f013f8207.png";